<template>
  <div class="lz-field">
    <label class="lz-field-label" for="categorySelect">Category</label>
    <select
      id="categorySelect"
      class="form-control"
      v-model="selectedCategory"
      @change="categoryChanged"
      :disabled="loadingType">
      <option value="def" selected v-if="loadingType">Please wait...</option>
      <option value="def" selected v-if="!loadingType">Select one...</option>
      <option v-for="cat in categories" :key="cat.value" :value="cat.value">
        {{ cat.name }}
      </option>
    </select>
  </div>
</template>

<script>
import ServicesOld from '../../services/index.vue'
import Services from '../../services/main.service.vue'

export default {
  name: 'CategoriesSelector',
  data() {
    return {
      loadingType: false,
      selectedCategory: 'def',
      categories: []
    }
  },
  computed: {
    Store() {
      return this.$store.getters
    },
    FormData() {
      return this.Store.formData
    },
    category() {
      return this.FormData.category
    }
  },
  async mounted() {
    this.loadingType = true
    const Categories = await ServicesOld.GetExpenseCategories()
    this.categories = Categories.data.content
    this.loadingType = false
  },
  methods: {
    categoryChanged() {
      if (this.category !== this.selectedCategory) {
        this.$store.commit('modifyFormData', {
          key: 'category',
          value: this.selectedCategory
        })
      }
    }
  }
}
</script>
